var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBaby(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 52.5,
    viewBox: "0 0 40 52.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ea5a47;}.cls-2{fill:#fadcbc;}.cls-3{fill:#92d3f5;}.cls-4{fill:#61b2e4;}.cls-5{stroke-linejoin:round;}.cls-5,.cls-6{stroke-linecap:round;}.cls-5,.cls-6,.cls-7{fill:none;stroke:#000;stroke-width:2px;}.cls-6,.cls-7{stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoji"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1,52.5v-1.9c0-8.4,1.1-25.7,4.1-32.1h30c3,6.3,3.9,23.6,3.9,32.1v1.9H1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39,52.5h-12v-16.5c0-3-1-4-1-4l5.4-2.9,4.4-8,1.4,3.6,1.8,27.8Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 20,
    cy: 25.5,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "skin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.1,15.7C35.1,6.6,28.9,0,20.1,0S5.1,6.5,5.1,15.7c0,6.3-.8,12.2,7.1,16.3,0,0,3.5,1,7.9,1,5,0,8-1.1,8-1.1,8-4,7-10,7-16.2Zm-15.1,12.8c-1.7,0-3-1.3-3-3s1.3-3,3-3,3,1.3,3,3-1.3,3-3,3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M11,18s1-1,2-1,2,1,2,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M25,18s1-1,2-1,2,1,2,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M35,19.3c3,3,4,21.7,4,29.7v2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1,51.5v-2.5c0-8,1-26.7,4-29.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 16,
    y1: 6,
    x2: 15,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 20,
    y1: 5,
    x2: 19,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 24,
    y1: 6,
    x2: 25,
    y2: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 20,
    cy: 25.5,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M16.7,25.6c-1.1-.3-1.7-.6-1.7-.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M25,25s-.5,.3-1.5,.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M28,32c8-3,7-12,7-15.8,0-8.9-6.2-15.2-15-15.2S5,7.3,5,16.2c0,3.8-1,12.8,7.1,15.8,3.7,1.4,12.1,1.3,15.9,0Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby);
export default __webpack_public_path__ + "static/media/baby.9f0b8d4278a9c7ecf6daf6c106eae978.svg";
export { ForwardRef as ReactComponent };